/**
 * Return true if next is a URL/path that represents external domain
 * @param {string} next
 * @return {boolean}
 */
export function isExternalRedirect(next) {
  if (!next) {
    // null
    return false;
  }
  if (!next.startsWith('http')) {
    // /some/next/path
    return false;
  }
  if (
    next.startsWith(`${window.location.protocol}://${window.location.hostname}`)
  ) {
    // same domain
    return false;
  }
  return true;
}
